const map = {
	"./Tool.svg": 99542,
	"./UtentiWeb.svg": 60611,
	"./UtenzeGestite.svg": 63876,
	"./amr gest.svg": 60733,
	"./gateway.svg": 13882,
	"./mr gest.svg": 49794,
	"./receiver.svg": 50103,
	"./wfm gest.svg": 69921
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13162;